import * as React from 'react';
import { Input } from '@makemydeal/ui-bricks';

interface IReduxFormInputFieldProps {
    analyticsId?: string;
    disabled?: boolean;
    id?: string;
    input: any;
    meta: any;
    overrideError?: boolean;
    placeholder?: string;
    type: string;
    label?: string;
}

class ReduxFormInputField extends React.Component<IReduxFormInputFieldProps, any> {
    constructor(props) {
        super(props);
    }

    render() {
        const { analyticsId, disabled, id, input, meta, type, label } = this.props;

        const className = meta.submitFailed && !meta.valid ? 'is-invalid' : '';

        return (
            <Input
                inputId={id || null}
                label={label}
                onBlurFunction={input.onBlur}
                name={input.name}
                data-analytics={analyticsId}
                type={type}
                value={input.value}
                disabled={disabled}
                onChangeFunction={input.onChange}
                className={className}
            />
        );
    }
}

export default ReduxFormInputField;
